export default __webpack_public_path__ + "static/media/no-photo.ac1b94f6.jpg";